<template>
  <div class="card">
    <div
      class="card-body"
    >
      <p class="card-text mb-3">
        Xml imports in progress
        <button
          class="btn btn-sm btn-outline-primary"
          @click.prevent="search"
        >
          <i class="jam jam-refresh" />
        </button>
      </p>
      <table
        class="table table-striped table-bordered with-header-border"
        v-if="entries && entries.length > 0"
      >
        <thead>
          <tr>
            <th>Run</th>
            <th>
              Agent
            </th>
            <th>Config</th>
            <th>
              <a
                href="#"
                @click.prevent="sortBy( e => e.start )"
              >
                Start
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="entry in entries"
            :key="entry.id"
          >
            <td>{{ entry.id }}</td>
            <td>
              <a :href="'/xmlimport?login=' + entry.agentCode">
                {{ entry.agentCode }}
              </a>
            </td>
            <td>
              properties: {{ entry.runConfig.numberOfProperties }} <span v-if="validPromotion( entry )">(upgraded to {{ entry.runConfig.promotionalProperties }})</span>
            </td>
            <td>{{ toLocaleString( entry.start ) }}</td>
          </tr>
        </tbody>
      </table>
      <div
        class="alert alert-info"
        v-else
      >
        No imports in progress
      </div>
    </div>
  </div>
</template>

<script>
import xmlimportsapi from '../../../xmlimportapi';
import notify from '../../../notifications';

export default {
    data() {
        return {
            entries: []
        };
    },
    async mounted() {
        this.search();
    },
    methods: {
        toLocaleString( dateInString ) {
            if ( !dateInString ) {
                return '';
            }
            const date = new Date( dateInString );
            return date.toLocaleString( [ 'es-ES', 'en-UK' ] );
        },
        sortBy( expression ) {
            this.entries.sort( ( a, b ) => {
                if ( expression( a ) > expression( b ) ) {
                    return -1;
                }

                if ( expression( a ) < expression( b ) ) {
                    return 1;
                }

                return 0;
            } );
        },
        sortByAsc( expression ) {
            this.entries.sort( ( a, b ) => {
                if ( expression( a ) > expression( b ) ) {
                    return 1;
                }

                if ( expression( a ) < expression( b ) ) {
                    return -1;
                }

                return 0;
            } );
        },
        validPromotion( entry ) {
            if ( !entry.runConfig.promotionStartDate || !entry.runConfig.promotionEndDate ) {
                return false;
            }
            const promotionStartDate = new Date( entry.runConfig.promotionStartDate );
            const promotionEndDate = new Date( entry.runConfig.promotionEndDate );

            const start = new Date( entry.start );

            return start >= promotionStartDate && start <= promotionEndDate;
        },
        async search() {
            this.$store.dispatch( 'appLoading', true );

            var url = '/inprogress';

            const response = await xmlimportsapi.get( url );

            if ( response.status !== 200 ) {
                this.$store.dispatch( 'appLoading', false );
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to imports in progress'
                } );
                return;
            }

            let entries = await response.json();

            this.entries = entries;

            this.$store.dispatch( 'appLoading', false );
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/inprogress.vue